import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/scxx_fx.png'
import _imports_1 from '@/assets/scxx_jb.png'
import _imports_2 from '../../assets/scxx_no.png'
import _imports_3 from '../../assets/scxx_ok.png'
import _imports_4 from '../../assets/bvlv_blue.png'
import _imports_5 from '../../assets/bvlv_zb.png'
import _imports_6 from '../../assets/zt_zanwushuju.png'
import _imports_7 from '@/assets/module_share_open.png'
import _imports_8 from '../../assets/module_share_open.png'
import _imports_9 from '../../assets/lxhz_icon.png'


const _hoisted_1 = { style: {"width":"12.8rem","margin":"0.7rem auto 0"} }
const _hoisted_2 = { class: "body_" }
const _hoisted_3 = { class: "body_left" }
const _hoisted_4 = { class: "body_left_video" }
const _hoisted_5 = { class: "body_left_title" }
const _hoisted_6 = { class: "body_left_click" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "body_left_fl" }
const _hoisted_9 = { class: "body_left_xx" }
const _hoisted_10 = { class: "body_left_xx" }
const _hoisted_11 = { class: "body_left_xx" }
const _hoisted_12 = { class: "body_right" }
const _hoisted_13 = {
  key: 0,
  class: "BR_Tab"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "BR_Tab"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "BR_Tab_price" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "BR_Tab_message" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "BR_Tab_xz" }
const _hoisted_25 = { class: "BR_Tab_Details" }
const _hoisted_26 = { class: "BR_TDM" }
const _hoisted_27 = { class: "BR_TDM_" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = {
  key: 0,
  style: {"width":"0.2rem"},
  src: _imports_2
}
const _hoisted_32 = {
  key: 1,
  style: {"width":"0.2rem"},
  src: _imports_3
}
const _hoisted_33 = { key: 3 }
const _hoisted_34 = {
  key: 0,
  style: {"width":"0.2rem"},
  src: _imports_2
}
const _hoisted_35 = {
  key: 1,
  style: {"width":"0.2rem"},
  src: _imports_3
}
const _hoisted_36 = { key: 4 }
const _hoisted_37 = {
  key: 0,
  style: {"width":"0.2rem"},
  src: _imports_3
}
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "br_main_user" }
const _hoisted_40 = { style: {"display":"flex","justify-content":"center","padding":"0.18rem 0"} }
const _hoisted_41 = {
  key: 0,
  class: "wVC_list_l_T_B_rz"
}
const _hoisted_42 = { class: "br_main_click" }
const _hoisted_43 = { class: "br_main_location" }
const _hoisted_44 = { class: "body_list" }
const _hoisted_45 = {
  key: 0,
  class: "zwsj",
  src: _imports_6
}
const _hoisted_46 = {
  key: 0,
  class: "zwsj",
  src: _imports_6
}
const _hoisted_47 = {
  key: 0,
  class: "module_inform"
}
const _hoisted_48 = { class: "module_inform_body" }
const _hoisted_49 = { class: "zf_body" }
const _hoisted_50 = { class: "zf_body_top" }
const _hoisted_51 = { class: "zf_b_M" }
const _hoisted_52 = { class: "zf_b_M_number" }
const _hoisted_53 = { class: "zf_fs_body" }
const _hoisted_54 = { class: "zf_fs_list" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["src"]
const _hoisted_57 = {
  key: 0,
  class: "zf_fs_icon",
  src: _imports_9,
  alt: ""
}
const _hoisted_58 = { class: "zf_fs_b" }
const _hoisted_59 = { style: {"text-align":"center","padding-top":"5px","font-size":"20px"} }
const _hoisted_60 = { style: {"display":"flex","justify-content":"center"} }

import { ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElTable } from "element-plus";
import moduleProvideMaterial from "../../components/moduleProvideMaterial.vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import TwoDimensionalCode from "@/views/ShadowComposer/components/TwoDimensionalCode.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ShadowMaterialVideoParticulars',
  setup(__props) {

const TwoDimensionalCodeRef = ref<any>();
const router = useRouter();
const module_informChecked = ref(false);
const reason = ref("");
const type = ref("");
const PartnersMobileNumber = ref(false);
const PartnersMobileNumber1 = ref();
//不能购买自己
const popZj = () => {
  ElMessage.warning("不能购买自己");
};
//支付金额
let moenyNumber = ref(0);
// 支付类型切换
let paymentTypeList = ref([
  // {
  //   title: "我的账户",
  //   img: require("../../assets/lxhz_pb.png"),
  //   checked: true,
  // },
  {
    title: "微信",
    img: require("../../assets/lxhz_wx.png"),
    checked: true,
  },
  {
    title: "支付宝",
    img: require("../../assets/lxhz_zfb.png"),
    checked: false,
  },
]);
let paymentTL_click = function (index) {
  for (let i = 0; i < paymentTypeList.value.length; i++) {
    if (index == paymentTypeList.value[i]) {
      paymentTypeList.value[i].checked = true;
    } else {
      paymentTypeList.value[i].checked = false;
    }
  }
};

const CloseQrCode = (e) => {
  payment.value = false;
  Axios(
    "get",
    "/member/contacts/phone/" + e,
    {},
    false,
    function (res) {
      // res;
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
      // PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    },
    function (res) { }
  );
};
let payment = ref(false);
// 获取联系合作 // index 回去对象的的id
let Contact = function (index) {
  Axios(
    "get",
    "/member/contacts/phone/" + index,
    {},
    false,
    function (res) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
    },
    function (res) {
      ElMessage({
        showClose: true,
        message: res.data.msg,
        type: "warning",
      });
      console.log(res.data.data);

      getMoney();
    }
  );
};
//获取金额
let getMoney = function () {
  Axios("get", "/member/contacts/pay-amount", {}, false, function (res) {
    moenyNumber.value = res.data.msg;
    payment.value = true;
  });
};
// 支付获取联系方式
let get_sjh = function (index) {
  Axios(
    "POST",
    "/member/contacts?memberId=" + index,
    {},
    false,
    function (res) {
      console.log(res.data);
    },
    function (res) {
      Axios(
        "POST",
        `/member/contacts/create-order/${index}`,
        {},
        false,
        function (res) {
          console.log();

          // console.log(res.data.data);
          TwoDimensionalCodeRef.value.init(
            res.data.data.qrcode,
            res.data.data.sceneId,
            index
          );
        },
        function (res) {
          console.log(res.data);
        }
      );
    }
  );
};
let id = router.currentRoute.value.query.id;
/* 获取当前数据接口 */
let list = ref({});
let use_list = ref([]);
let userList = ref([]);
let report = ref(false);
let getuserMassage = function (id) {
  console.log(id);
  Axios("GET", "/member/info/" + id, false, false, function (res) {
    userList.value = res.data.data;
    console.log(res.data);
  });
};
document.title = "标识山西-找素材-视频素材";
const getList = function () {
  Axios("get", "/fodder/info/" + id, false, false, function (res) {
    console.log("res.data.data", res.data.data.createUser);
    if (JSON.parse(localStorage.getItem("userList"))) {
      res.data.data.createUser ==
        JSON.parse(localStorage.getItem("userList")).memberId
        ? (res.data.data.Shop = true)
        : (res.data.data.Shop = false);
    } else {
      res.data.data.Shop = false;
    }

    list.value = res.data.data;
    let a = localStorage.getItem("userList") != null ? JSON.parse(localStorage.getItem("userList")).memberId : "";
    report.value = list.value.createUser == a;
    playerOptions.value.sources[0].src = res.data.data.filePath;
    let uses = res.data.data.uses;
    document.title += res.data.data.title;
    videoUse(uses);
    user_other();
    likeness_other();
    getuserMassage(list.value.createUser);
  });
};
getList();
const module_informOverNo = () => {
  module_informChecked.value = false;
  type.value = "";
  reason.value = "";
};
const module_informOverNo1 = () => {
  module_informChecked.value = true;
};
const handleReport = function () {
  if (!type.value) {
    ElMessage.warning("请选择举报类型");
    return;
  }
  Axios(
    "POST",
    "/fodder/report",
    { materialId: id, remark: type.value },
    null,
    false,
    function (res) {
      ElMessage.success("举报成功");
      module_informChecked.value = false;
      // emit("openClickOverOpen");
    }
  );
};
const videoUse = (uses) => {
  Axios("get", "/fodder/video-use", false, false, function (res) {
    res.data.data.forEach((item, index) => {
      if (uses) {
        const result = Object.values(item).some((val) => {
          console.log(val);
          uses.includes(val);
        });
        console.log("result", result);

        if (result) {
          item.show = true;
        } else {
          item.show = false;
        }
      } else {
        item.show = false;
      }
    });
    use_list.value = res.data.data;
  });
};

// console.log(JSON.parse(localStorage.getItem("userList")), "登录信息");

const tabList = ref([
  {
    title: "个人授权",
    authType: "SELF",
    checked: true,
  },
  {
    title: "企业授权",
    authType: "ENTERPRISE",
    checked: false,
  },
  {
    title: "企业Plus",
    authType: "UNION",
    checked: false,
  },
]);
const tabList1 = ref([
  {
    title: "个人授权",
    authType: "SELF",
    checked: true,
  },
]);
const tabListType = ref("SELF");
const selectPrice = ref(0);
const BR_TabClick = function (index, arrI) {
  selectPrice.value = arrI;
  for (let i = 0; i < tabList.value.length; i++) {
    if (tabList.value[i] == index) {
      tabList.value[i].checked = true;
      tabListType.value = tabList.value[i].authType;
    } else {
      tabList.value[i].checked = false;
    }
  }
};
/*作者其它作品*/
const videoList = ref([]);
const user_other = () => {
  Axios(
    "get",
    "/fodder/front/list",
    {
      // isOnline: 0,
      materialType: "VIDEO",
      paramIndex: 2, //(排序方式（0默认1最新2热门）)
      status: 1,
      pageNum: 1,
      pageSize: 4,
      materialId: id,
      memberId: list.value.createUser,
    },
    false,
    (res) => {
      // console.log(res, '分类')
      if (res.data.rows.length == 0) {
        videoList.value = [];
      } else {
        let new_srcList = res.data.rows;
        setTimeout(() => {
          videoList.value = new_srcList;
        }, 200);
      }
    }
  );
};

/*相似类型*/
const videoLikenessList = ref([]);
const likeness_other = () => {
  Axios(
    "get",
    "/fodder/front/list",
    {
      // isOnline: 0,
      materialType: "VIDEO",
      paramIndex: 2, //(排序方式（0默认1最新2热门）)
      status: 1,
      pageNum: 1,
      pageSize: 8,
      materialId: id,
      typeIds: list.value.typeIds,
    },
    false,
    (res) => {
      // console.log(res, '分类')
      if (res.data.rows.length == 0) {
        videoLikenessList.value = [];
      } else {
        let new_srcList = res.data.rows;
        setTimeout(() => {
          videoLikenessList.value = new_srcList;
        }, 200);
      }
    }
  );
};
/* 加入购物车 */
const shoppingTrolley = function () {
  Axios(
    "POST",
    "/fodder/car",
    {
      materialId: list.value.id,
      authType: tabListType.value,
    },
    false,
    function (res) {
      ElMessage({
        showClose: true,
        message: "已加入购物车",
        type: "success",
      });
    }
  );
};
/* 下载 */
const downloadClick = function () {
  Axios(
    "GET",
    "/fodder/down",
    {
      materialId: id,
    },
    false,
    function (res) {
      router.push({
        path: "/purchasedMaterial",
      });
    },
    function (res) {
      if (res.data.code == 100) {
        Axios("get", "/fodder/order/check/" + id, {}, false, (res) => {
          router.push({
            path: "/myOrderDetial",
            query: {
              arry: id,
              authType: tabListType.value,
              totalPay: 0,
              type: "order",
            },
          });
        });
      }
    }
  );
};
const allWorksClick = function () {
  router.push({
    path: "/ShadowMaterialVideoList",
  });
};

const playerOptions = ref({
  autoplay: false,
  controls: true,
  muted: false,
  controlBar: {
    durationDisplay: true,
    volumePanel: {
      inline: false,
    },
  },
  sources: [
    {
      src: "",
      type: "video/mp4",
    },
  ],
});
//关注/取消关注
let attention = function () {
  if (userList.value.isFollow == false) {
    Axios(
      "POST",
      "/member/member-follow",
      {
        memberId: userList.value.memberId,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "关注成功",
          type: "success",
        });
        getuserMassage(userList.value.memberId);
      }
    );
  } else {
    Axios(
      "DELETE",
      "/member/member-follow",
      {
        memberId: userList.value.memberId,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已取消关注",
          type: "success",
        });
        getuserMassage(userList.value.memberId);
      }
    );
  }
};
// 视频详情
const goParticulars = function (index) {
  console.log(index.id);

  router
    .push({
      path: "/ShadowMaterialVideoParticulars",
      query: {
        id: index.id,
      },
    })
    .then(() => {
      location.reload();
    });
};
// 创作人跳转
const Composer = function (id) {
  router.push({
    path: "/ShadowComposerHomepage",
    query: {
      id: id,
    },
  });
};
// 搜藏
let click_sc = function () {
  // --收藏
  if (list.value.isCollect == 0) {
    Axios(
      "post",
      "/fodder/collect",
      {
        materialId: list.value.id,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已收藏",
          type: "success",
        });
        getList();
      }
    );
  } else {
    //  --取消收藏
    Axios(
      "delete",
      "/fodder/collect",
      {
        materialId: list.value.id,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已取消收藏",
          type: "warning",
        });
        getList();
      }
    );
  }
};
// 复制链接
const click_fzlj = function () {
  navigator.clipboard.writeText(window.location.href).then(() => {
    ElMessage({
      showClose: true,
      message: "复制成功",
      type: "success",
    });
  });
};
const collectIds = ref([])
const getCollects = async () => {
  await Axios(
    "get",
    "/fodder/collect/collect-ids",
    {
    },
    false,
    (res) => {
      collectIds.value = res.data.data
    }
  );
}
getCollects();

return (_ctx: any,_cache: any) => {
  const _component_video_player = _resolveComponent("video-player")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_video_player, {
            id: "myVideo",
            class: "custom-video-player",
            ref: "videoPlayer",
            options: playerOptions.value
          }, null, 8, ["options"])
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(list).title), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(click_sc) && _unref(click_sc)(...args))),
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("img", {
              src: (_unref(list).isCollect == 0 || !_unref(list).isCollect)
              ? require('@/assets/music_b_SC.png')
              : require('@/assets/music_b_SC_OK.png')
              
            }, null, 8, _hoisted_7),
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "收藏", -1))
          ]),
          _createElementVNode("div", {
            onClick: click_fzlj,
            style: {"cursor":"pointer"}
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("span", null, "复制链接", -1)
          ])),
          (!_unref(report))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: module_informOverNo1,
                style: {"cursor":"pointer"}
              }, _cache[14] || (_cache[14] = [
                _createElementVNode("img", { src: _imports_1 }, null, -1),
                _createElementVNode("span", null, "举报", -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list).typeNames, (index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: {}
            }, _toDisplayString(index), 1))
          }), 128))
        ]),
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createTextVNode(" 视频长度： ")),
                  _createElementVNode("span", null, _toDisplayString(_unref(list).playTime), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _cache[16] || (_cache[16] = _createTextVNode(" 视频ID： ")),
                  _createElementVNode("span", null, _toDisplayString(_unref(list).code), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _cache[17] || (_cache[17] = _createTextVNode(" 更新时间： ")),
                  _createElementVNode("span", null, _toDisplayString(_unref(list).updateTime), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "body_left_xx" }, [
          _createTextVNode(" 使用限制： "),
          _createElementVNode("span", null, " 无 ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_unref(list).selfPrice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (index, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  onClick: ($event: any) => (BR_TabClick(index, i)),
                  key: index,
                  class: _normalizeClass(index.checked ? 'BR_TabY' : 'BR_TabF')
                }, _toDisplayString(index.title), 11, _hoisted_14))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList1.value, (index, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  onClick: ($event: any) => (BR_TabClick(index, i)),
                  key: index,
                  class: _normalizeClass(index.checked ? 'BR_TabY' : 'BR_TabF')
                }, _toDisplayString(index.title), 11, _hoisted_16))
              }), 128))
            ])),
        _createElementVNode("div", _hoisted_17, [
          (selectPrice.value == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(list).selfPrice ? "￥" + (_unref(list).selfPrice / 1).toFixed(2) : "免费"), 1))
            : _createCommentVNode("", true),
          (selectPrice.value == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(list).enterPrice ? "￥" + (_unref(list).enterPrice / 1).toFixed(2) : "免费"), 1))
            : _createCommentVNode("", true),
          (selectPrice.value == 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(list).enterPlusPrice
            ? "￥" + (_unref(list).enterPlusPrice / 1).toFixed(2)
            : "免费"), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createTextVNode(_toDisplayString(_unref(list).resolutionRate && _unref(list).resolutionRate) + "   " + _toDisplayString(_unref(list).frameRate && "@" + _unref(list).frameRate + "fps") + " ", 1),
          (_unref(list).resolutionRate || _unref(list).frameRate)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(list).fileExt) + " ", 1),
          (_unref(list).bitRate)
            ? (_openBlock(), _createElementBlock("span", _hoisted_23))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(list).bitRate && _unref(list).bitRate / 1000 + "Kbps") + " ", 1),
          _cache[19] || (_cache[19] = _createElementVNode("span", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(list).fileSize), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          (_unref(list).Shop)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "download",
                onClick: popZj
              }, "下载"))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "download",
                onClick: downloadClick
              }, "下载")),
          (_unref(list).Shop && _unref(list).selfPrice != 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "shopping",
                onClick: popZj
              }, " 加入购物车 "))
            : (_unref(list).selfPrice != 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "shopping",
                  onClick: shoppingTrolley
                }, " 加入购物车 "))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "BR_Tab_Details_top" }, [
            _createElementVNode("div", { class: "BR_TDT_left" }, "视频素材用途"),
            _createElementVNode("div", { class: "BR_TDT_right" }, [
              _createElementVNode("span", { style: {"margin-right":"0.12rem"} }, "授权范围"),
              _createElementVNode("span", null, "授权书范本")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(use_list), (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (selectPrice.value == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.dictLabel), 1))
                  : (selectPrice.value != 0 && index > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(item.dictLabel), 1))
                    : _createCommentVNode("", true),
                (selectPrice.value == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (index > 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                        : (_openBlock(), _createElementBlock("img", _hoisted_32))
                    ]))
                  : _createCommentVNode("", true),
                (selectPrice.value == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      (index > 5)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                        : (index > 1)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (selectPrice.value == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (index > 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_37))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("div", {
          class: "br_main",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (Composer(_unref(list).createUser)))
        }, [
          _createElementVNode("img", {
            style: {"height":"0.8rem","border-radius":"50%"},
            src: _unref(list).avatar ? _unref(list).avatar : require('../../assets/logo.png')
          }, null, 8, _hoisted_38),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("span", null, _toDisplayString(_unref(list).createUserName), 1)
          ]),
          _createElementVNode("view", _hoisted_40, [
            (_unref(userList).professionalStatus == 2)
              ? (_openBlock(), _createElementBlock("view", _hoisted_41, [
                  _cache[21] || (_cache[21] = _createElementVNode("img", { src: _imports_4 }, null, -1)),
                  _createTextVNode(" 标识山西认证" + _toDisplayString(_unref(userList).profess), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", {
              class: "BDC_gz",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(attention) && _unref(attention)(...args)), ["stop"]))
            }, _toDisplayString(_unref(userList).isFollow ? "取消关注" : "关注"), 1)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[22] || (_cache[22] = _createElementVNode("img", { src: _imports_5 }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref(userList).realDAddress || "暂无具体地址"), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", null, [
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "SL_hotSongwriter" }, [
          _createElementVNode("div", { class: "SL_hotSongwriter_title" }, "作者其他素材")
        ], -1)),
        (videoList.value.length == 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_45))
          : (_openBlock(), _createBlock(_component_el_row, {
              key: 1,
              gutter: 20
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, (index) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    span: 6,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(moduleProvideMaterial, {
                        collectIds: collectIds.value,
                        onClick: ($event: any) => (goParticulars(index)),
                        class: "SL_offerMaterialListdiv",
                        message: index
                      }, null, 8, ["collectIds", "onClick", "message"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("div", null, [
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "SL_hotSongwriter" }, [
          _createElementVNode("div", { class: "SL_hotSongwriter_title" }, "相似素材")
        ], -1)),
        (videoLikenessList.value.length == 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_46))
          : (_openBlock(), _createBlock(_component_el_row, {
              key: 1,
              gutter: 20
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoLikenessList.value, (index) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    span: 6,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(moduleProvideMaterial, {
                        collectIds: collectIds.value,
                        onClick: ($event: any) => (goParticulars(index)),
                        class: "SL_offerMaterialListdiv",
                        message: index
                      }, null, 8, ["collectIds", "onClick", "message"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
      ])
    ]),
    (module_informChecked.value)
      ? (_openBlock(), _createElementBlock("view", _hoisted_47, [
          _createElementVNode("view", _hoisted_48, [
            _createElementVNode("view", { class: "module_share_body_top" }, [
              _cache[25] || (_cache[25] = _createElementVNode("view", null, "选择举报理由", -1)),
              _createElementVNode("img", {
                onClick: module_informOverNo,
                src: _imports_7
              })
            ]),
            _createElementVNode("view", null, [
              _createElementVNode("view", null, [
                _createVNode(_component_el_radio_group, {
                  modelValue: type.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((type).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "1" }, {
                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                _createTextVNode("违法违禁")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "2" }, {
                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                _createTextVNode("政治敏感")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "3" }, {
                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                _createTextVNode("色情低俗")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "4" }, {
                              default: _withCtx(() => _cache[29] || (_cache[29] = [
                                _createTextVNode("人身攻击")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "5" }, {
                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                _createTextVNode("垃圾广告")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "6" }, {
                              default: _withCtx(() => _cache[31] || (_cache[31] = [
                                _createTextVNode("刷屏")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "7" }, {
                              default: _withCtx(() => _cache[32] || (_cache[32] = [
                                _createTextVNode("其他问题")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _withDirectives(_createElementVNode("textarea", {
                placeholder: "请输入举报内容",
                maxLength: "100",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((reason).value = $event)),
                class: "module_share_textarea"
              }, null, 512), [
                [_vModelText, reason.value]
              ]),
              _createElementVNode("view", { class: "module_share_button" }, [
                _createElementVNode("button", {
                  class: "module_share_button_Y",
                  onClick: handleReport
                }, " 确定 "),
                _createElementVNode("button", {
                  class: "module_share_button_N",
                  onClick: module_informOverNo
                }, " 取消 ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "",
      "show-close": false,
      modelValue: _unref(payment),
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(payment) ? (payment).value = $event : payment = $event)),
      "align-center": "",
      width: "4.8rem",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _cache[33] || (_cache[33] = _createElementVNode("span", null, "联系合作", -1)),
            _createElementVNode("img", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(payment) //@ts-ignore
 ? payment.value = false : payment = false)),
              class: "cur",
              src: _imports_8
            })
          ]),
          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "zf_body_title" }, "支付相应费用，获得联系方式", -1)),
          _createElementVNode("div", _hoisted_51, [
            _cache[35] || (_cache[35] = _createElementVNode("span", { CLASS: "zf_b_M_title" }, "应付金额：", -1)),
            _createElementVNode("span", _hoisted_52, [
              _cache[34] || (_cache[34] = _createElementVNode("text", { class: "zf_b_M_n_icon" }, "￥", -1)),
              _createTextVNode(_toDisplayString((_unref(moenyNumber) / 1).toFixed(2)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "zf_fs_title" }, "选择付款方式", -1)),
            _createElementVNode("div", _hoisted_54, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentTypeList), (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_unref(paymentTL_click)(index))
                }, [
                  _createElementVNode("img", {
                    class: "zf_fs_logo cur",
                    src: index.img
                  }, null, 8, _hoisted_56),
                  _createElementVNode("span", null, _toDisplayString(index.title), 1),
                  (index.checked)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_57))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_55))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", {
              class: "zf_fs_b_qx cur",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_isRef(payment) //@ts-ignore
 ? payment.value = false : payment = false))
            }, "取消"),
            _createElementVNode("div", {
              class: "zf_fs_b_qd cur",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(get_sjh)(_unref(userList).memberId)))
            }, " 确定 ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: PartnersMobileNumber.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((PartnersMobileNumber).value = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[38] || (_cache[38] = _createElementVNode("div", { style: {"text-align":"center"} }, "联系方式", -1)),
        _createElementVNode("div", _hoisted_59, _toDisplayString(PartnersMobileNumber1.value), 1),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (PartnersMobileNumber.value = false))
          }, " 取消 "),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (PartnersMobileNumber.value = false))
          }, " 确认 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(TwoDimensionalCode, {
      ref_key: "TwoDimensionalCodeRef",
      ref: TwoDimensionalCodeRef,
      CloseQrCode: CloseQrCode
    }, null, 512)
  ]))
}
}

})